import React from "react";
import { SeverityLevel } from "@microsoft/applicationinsights-web";
import { trackException } from "../../telemetry/applicationInsights";
import "./AppErrorBoundary.css";

type AppErrorBoundaryProps = {
  children: React.ReactNode;
};

type AppErrorBoundaryState = {
  hasError: boolean;
};

class AppErrorBoundary extends React.Component<AppErrorBoundaryProps, AppErrorBoundaryState> {
  public state: AppErrorBoundaryState = {
    hasError: false,
  };

  public static getDerivedStateFromError(): AppErrorBoundaryState {
    return {
      hasError: true,
    };
  }

  public componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    trackException(
      error,
      {
        source: "react.errorBoundary",
        componentStack: errorInfo.componentStack,
      },
      SeverityLevel.Critical
    );
  }

  private refreshPage = (): void => {
    window.location.reload();
  };

  private goHome = (): void => {
    window.location.href = "/rapp";
  };

  public render(): React.ReactNode {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <main className="appErrorBoundary" role="alert">
        <div className="appErrorBoundary__content">
          <h1 className="appErrorBoundary__title">Something went wrong</h1>
          <p className="appErrorBoundary__message">
            We could not load this screen. Please refresh the app or go back home.
          </p>
          <div className="appErrorBoundary__actions">
            <button
              className="appErrorBoundary__button"
              type="button"
              onClick={this.refreshPage}
            >
              Refresh
            </button>
            <button
              className="appErrorBoundary__button appErrorBoundary__button--secondary"
              type="button"
              onClick={this.goHome}
            >
              Go home
            </button>
          </div>
        </div>
      </main>
    );
  }
}

export default AppErrorBoundary;
